<template>
  <div id="dashboard">
    <!-- IMAGE -->
    <v-img
      class="background-image"
      :src="require(`@/assets/images/dashboard/${configBgImage}`)"
    ></v-img>

    <!-- MODAL: PIPE METER / Two or Three Monitors -->
    <PipeMeterModal
      v-if="isShowDescription"
      :isShowDescription="isShowDescription"
      :monitorType="viewType"
      :title="viewTitle"
      :groupId="viewGroupId"
      :deviceId="deviceId"
      :siteTitle="siteTitle"
      @onCloseModal="isShowDescription = false"
    ></PipeMeterModal>

    <!-- MODAL: LEVEL METER Single Monitor-->
    <LevelMeterModal
      v-if="isShowLevel"
      :isShowLevel="isShowLevel"
      :title="viewTitle"
      :deviceId="deviceId"
      :siteTitle="siteTitle"
      @onCloseModal="isShowLevel = false"
    ></LevelMeterModal>

    <!-- MONITOR: TANK -->
    <template v-for="(tank, i) in configTanks">
      <div class="charger-bar"
        :key="'charger-bar-'+i"
        :style="{
          top: `${tank.animatePos.top}%`,
          left: `${tank.animatePos.left}%`,
          height: `${tank.animatePos.height}%`,
          zIndex: 99
        }"
        @click.prevent="handlerClickMeter(tank.deviceId, '', tank.type, tank.title)"
      >
        <div class="charger-block" 
          :style="{width: `${tank.animatePos.blockWidth}vw`}"
        >
          <div v-for="i in 10" :key="'charger-block-'+i" style="height: 100%">
            <div v-if="i > 10 - champagneBar(tank.valTank.curVol, tank.valTank.maxVol)" 
              class="bar-cell"
            >
            </div>
            <div v-else class="bar-cell-hidden"></div>
          </div>
          <div class="fillup"></div>
          <div class="fillup2"
            :style="{
              height: `${champagneBar(tank.valTank.curVol, tank.valTank.maxVol) * 10}%`
            }"
          >
          </div>
        </div>
      </div>

      <!-- text on tank -->
      <div :key="'text-tank-'+i"
        class="text--digital--medium"
        :style="{
          top: `${tank.top}%`,
          left: `${tank.left}%`,
          position: `absolute`,
          textAlign: `end`,
          lineHeight: `1vw`,
        }"
      >
        <span 
          class="text-letGoDigital" 
          :class="renderValMeter(tank.valTank.perc) === 'ERROR' ? 'red--text' : 'white--text'"
        >
          {{ renderValMeter(tank.valTank.perc) }} %
        </span>
        <br>
        <span 
          class="text-letGoDigital"
          :class="renderValMeter(tank.valTank.curVol) === 'ERROR' ? 'red--text' : 'white--text'"  
        >
          {{ renderValMeter(tank.valTank.curVol) }} m<sup>3</sup>
        </span>
        <br>
        <span 
          class="text-letGoDigital"
          :class="renderValMeter(tank.valTank.maxVol) === 'ERROR' ? 'red--text' : 'white--text'"
        >
          {{ renderValMeter(tank.valTank.maxVol) }} m<sup>3</sup>
        </span>
      </div>
    </template>

    <!-- MONITOR: METER -->
    <template v-for="waterIn in configMeter" style="z-index: 9999;">
      <div v-for="(meter, j) in waterIn.valMeters" :key="meter.key"
        class="meter text--digital"
        :style="{
          top: `${waterIn.top + (j == 0 ? 0 : j == 1 ? 3 : 6)}%`,
          left: `${waterIn.left}%`,
          position: `absolute`,
          lineHeight: `1vw`,
          zIndex: 99
        }"
        @click.prevent="handlerClickMeter(waterIn.deviceId, waterIn.group, waterIn.type, waterIn.title)"
      >
        <div class="text-letGoDigital"
          :class=" meter.error == 0 ? 'color--digitalColor' : 'color--digitalColor-error'"
          v-html="meterUnitName(meter.val, meter.type, meter.error)"
        >
        </div>
      </div>
    </template>

    <!-- RENDER: PIPE -->
    <template v-for="item in configPipes">
      <v-img class="background-image"
        v-if="item.status" 
        :src="item.src"
        :key="item.key"
      >  
      </v-img>
    </template>

    <!-- RENDER: ARROW -->
    <template v-for="item in configArrows">
      <v-img
        v-if="item.status"
        :class="item.style"
        :key="item.key"
        :src="getArrowImage(item.name)"
        :style="{
          top: `${item.top}%`,
          left: `${item.left}%`,
          width: `${item.w}vw`,
          height: `${item.h}vw`,
          position: 'absolute'
        }"
      >  
      </v-img>
    </template>

    <!-- TEXT: LAST UPDATE -->
    <div style="position: absolute; bottom: 0.5%; right: 0.5%;">
      <span class="white--text">อัปเดตล่าสุดวันที่ {{ displayDate(this.lastUpdateDate) }} เวลา {{ this.lastUpdateTime }}</span>
    </div>

    <!-- TRICK HEIGHT -->
    <div :style="`height: ${setPageHeightByUrl}vw; position: relative;`"></div>
  </div>
</template>

<script>
// * IMPORT COMPONENTs
import LevelMeterModal from "@/components/modals/LevelMeterModal.vue";
import PipeMeterModal from "@/components/modals/PipeMeterModal.vue";

// * IMPORT CONFIGs 
import { siteInfo } from "@/helpers/constants.js";
// ! USE THE NAMESPACE AS THE SAME OF configId in constants.js of each site
// ! DO NOT FORGET TO DECLARE MODULE IN data
import * as phattanaGudreiadum from "@/helpers/configs/phattanaGudreiadum.js"

// * IMPORT SERVICEs
import services from "@/services/services";

// * IMPORT LIB. FUNCTIONs
import moment from "moment";

// * IMPORT OWN FUNCTIONs
import renderingFunction from "@/helpers/renderingFunction.js";

export default {
  mixins: [renderingFunction],
  components: {
    LevelMeterModal,
    PipeMeterModal
  },

  data() {
    return {
      // CONFIG SITE-INFO
      siteId: "",
      siteTitle: {
        title: "",
        subTitle: "",
      },

      // DECLARE MODULE CALLING
      modules: {
        phattanaGudreiadum: phattanaGudreiadum
      },
      
      // MODAL
      isShowDescription: false,
      isShowLevel: false,
      viewType: '',
      viewTitle: '',
      deviceId: '',
      viewGroupId: '',

      // CONFIG OBJECT-POSITION
      configBgImage: null,
      configMeter: null,
      configTanks: null,
      configPipes: null,
      configArrows: null,
      configObsHole: null,

      // DATETIME LASTEST UPDATE
      lastUpdateDate: '',
      lastUpdateTime: '',

      // QUERY DECLARATION
      intervalQueryTime: 10,
      intervalQuery: null,
    };
  },

  computed: {
    setPageHeightByUrl() {
      return 53;
    },
  },

  created() {
    moment.locale("th");
    this.setConfig();
  },

  mounted() {
    this.queryDataAllCurrent();
    this.intervalQuery = setInterval(() => {
      this.queryDataAllCurrent();
    }, this.intervalQueryTime * 1000);
  },

  destroyed() {
    clearInterval(this.intervalQuery);
  },

  methods: {
    // ! SETTING CONFIG
    setConfig() {
      // Set siteId
      this.siteId = this.$route.params.siteId;
      // Set siteTitle
      this.siteTitle.title = siteInfo.filter(
        (item) => item.id == this.siteId
      )[0].title;
      // Set siteSubTitle
      this.siteTitle.subTitle = siteInfo.filter(
        (item) => item.id == this.siteId
      )[0].cardSubTitle;

      try {
        // Set siteConfigId
        const siteConfigId = siteInfo.filter(
          (item) => item.id == this.siteId
        )[0].configId;
        var siteConfigByModuleImport = this.modules[siteConfigId];
        // console.log('MODULE: ', siteConfigByModuleImport);

        // Set Config of each site
        this.configBgImage = siteConfigByModuleImport.bgImage;
        this.configMeter = siteConfigByModuleImport.metersTextPosition;
        this.configTanks = siteConfigByModuleImport.tanksTextPosition;
        this.configPipes = siteConfigByModuleImport.pipesPosition;
        this.configArrows = siteConfigByModuleImport.arrowsPosition;
        // this.configObsHole = siteConfigByModuleImport.obsHolePosition;
      } catch (error) {
        console.error("[SYSTEM] Failed to set config position of each item : ", error);
      }
    },

    // ! SET METER VALUE OF EACH SITE BY ID
    setSitePhattana(slot1) {
      // Set midTank
      this.setTankValue(0, slot1['4708130200201LEVEL_VOLUME'], slot1['4708130200201LEVEL_PERCENT'] > 100 ? 100 : slot1['4708130200201LEVEL_PERCENT'], 500);
      this.setTankValue(1, slot1['4708130200201LEVEL_VOLUME'], slot1['4708130200201LEVEL_PERCENT'] > 100 ? 100 : slot1['4708130200201LEVEL_PERCENT'], 500);
      
      // Set mainTank
      this.setTankValue(2, slot1['4708130200701LEVEL_VOLUME'], slot1['4708130200701LEVEL_PERCENT'] > 100 ? 100 : slot1['4708130200701LEVEL_PERCENT'], 300);
      
      // Set pipeSensor
      this.setMeterValue(0, slot1['4708130201001TDS'], 0);
      this.setMeterValue(1, slot1['4708130201002TDS'], 0);
    
      // Set time
      this.lastUpdateDate = slot1['date'];
      this.lastUpdateTime = slot1['time'];
    },

    // ! SET METER RENDER
    setMeterValue(meterIndex, meterVal, valIndex) {
      if (!meterVal && meterVal !== 0) {
        this.configMeter[meterIndex].valMeters[valIndex].val = 'Error';
        this.configMeter[meterIndex].valMeters[valIndex].error = 1;
      } else {
        this.configMeter[meterIndex].valMeters[valIndex].error = 0;
        this.meterChanged(
          `this.configMeter[${meterIndex}].valMeters[${valIndex}].val`,
          this.configMeter[meterIndex].valMeters[valIndex].val,
          Math.abs(meterVal)
        );
      }
    },
    setTankValue(meterIndex, meterVal, meterValPerc, limitMax=0) {
      if (!meterVal && meterVal !== 0) {
        this.configTanks[meterIndex].valTank.curVol = 'Error';
      } else {
        var val = meterVal;
        if (meterVal > limitMax) {
          val = limitMax;
        }
        this.meterChanged(
          `this.configTanks[${meterIndex}].valTank.curVol`,
          this.configTanks[meterIndex].valTank.curVol,
          Math.abs(val)
        );
        this.configTanks[meterIndex].valTank.perc = meterValPerc;
      }
    },
    setGraphicBasedOnFlow(arrowGroupId, pipeId, flowVal) {
      if (flowVal && flowVal > 0) {
        this.configPipes.filter(item => item.key === pipeId).map(ele => ele.status = true);
        this.configArrows.filter(item => item.groupId === arrowGroupId).map(ele => ele.status = true);
      } else {
        this.configPipes.filter(item => item.key === pipeId).map(ele => ele.status = false);
        this.configArrows.filter(item => item.groupId === arrowGroupId).map(ele => ele.status = false);
      }
    },
    champagneBar(cur, max) {
      // console.log(Math.floor((cur / max) * 10));
      return Math.floor((cur / max) * 10);
    },
    getArrowImage(direction) {
      return require(`@/assets/arrow/Arrow_${direction}.svg`);
    },
    getRandomDecimal(min=0, max) {
      return (Math.random() * (max - min) + min).toFixed(2);
    },

    // ! HANLDER CLICK ACTION
    handlerClickMeter(deviceId, groupId, type, title) {
      // console.log(title, ' - deviceId: ', deviceId, ' - ', type);
      this.viewGroupId = groupId;
      this.deviceId = deviceId;
      this.viewType = type;
      this.viewTitle = title;

      if(type === "tank") {
        this.isShowLevel = true;
      } else {
        this.isShowDescription = true;
      }
    },

    // ! API SERVICES
    async queryDataAllCurrent() {
      let res = await services.getMetersDataAllCurrent(this.siteId);
      // console.log(this.siteId, ' - dashboard.GetAll RES: ', res['data']);
      if(res['data']) {
        try {
          switch (this.siteId) { 
            case 'sakonnakhon_banpattana':
              // ? call function set meter value by site
              this.setSitePhattana(res['data']['iot_470813'][0]);
              // console.log('[SYSTEM] Try setting nongwangYangkham');
              break;
          
            default:
              break;
          }
        } catch (error) {
          console.error('[SYSTEM] Error occured while trying set meter value: ', error);
        }
      }
    },
  }
}
</script>

<style scoped>
.background-image {
  width: 100% !important;
  height: 100% !important;
  position: absolute;
}
.arrow-image {
  position: absolute;
}
.meter:hover {
  cursor: pointer;
}
</style>